export default {
      id: "icon-heart-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-heart",
      toString: function () {
        return this.url;
      }
    }